class FamilyController {

    constructor() {
        this.model = plannerApplication.studyPlannerProfile.getFamily();
        this.view = new FamilyView(this);

        bindRadioToModel(this.view.relationshipRadio, this.model, 'inRelationship','Y');
        bindSliderToModel(this.view.relationshipTime, this.model, 'timeWithPartner', hourRangeUpdated);
        bindRadioToModel(this.view.childrenRadio, this.model, 'hasDependentChildren', 'Y');

    }

    initialiseChildOption(childOptionView) {
        childOptionView.model = this.model.getChildActivities().at(childOptionView.optionNo - 1);
        childOptionView.selectCheckbox.change(function () {
            this.onChildOptionChanged(childOptionView);
        }.bind(this));
        childOptionView.selectCheckbox.setChecked(childOptionView.model.isSelected());
        childOptionView.dayAndHoursSelector.updateSelected(
            childOptionView.model.getHours(),
            childOptionView.model.getDays()
        );
    }

    onChildOptionChanged(childOptionView) {
        let isSelected = childOptionView.selectCheckbox.isChecked();
        childOptionView.model.setSelected(isSelected);
        plannerApplication.userDataUpdated();
    }

    onHoursSelectionChanged(childOptionView, hours) {
        childOptionView.model.setHours(hours);
        plannerApplication.userDataUpdated();
    }

    onDaySelectionChanged(childOptionView, days) {
        childOptionView.model.setDays(days);
        plannerApplication.userDataUpdated();
    }
}
